export default __webpack_public_path__ + "static/media/Group9201.ee61c7ab.svg";